"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBannerDefaultProps = exports.BANNER_PADDING = exports.FONT_SIZE = exports.TEXT_COLOR = void 0;

var _interfaces = require("./interfaces");

var TEXT_COLOR = 'neutral90';
exports.TEXT_COLOR = TEXT_COLOR;
var FONT_SIZE = 'T100';
exports.FONT_SIZE = FONT_SIZE;
var BANNER_PADDING = 16;
exports.BANNER_PADDING = BANNER_PADDING;
var MessageBannerDefaultProps = {
  type: _interfaces.MessageBannerType.Informational,
  dismissButtonAltText: 'Dismiss this message',
  'aria-live': 'polite'
};
exports.MessageBannerDefaultProps = MessageBannerDefaultProps;